@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.body {
  @include inter-regular;
  font-size: 15px;
  line-height: 21px;
  color: $grey-90;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
    color: var(--dark-80);
  }

  li,
  li p {
    padding: 0 !important;
  }
}
